import { inject } from '@angular/core';
import { CanActivateFn, Router, Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';
import { GlobalService } from '../services/global.service';

const userMappingAccessGuard: CanActivateFn = () => {
    const globalService = inject(GlobalService);
    const router = inject(Router);
    const userDetails = globalService.getUserDetails();
    return userDetails.activeGeoLevel === 'block' ? true : router.createUrlTree(['/dashboard']);
};

export const userMappingRoutes: Routes = [
    {
        path: 'user-mapping/pg-mapping-view',
        loadComponent: () =>
            import('../user-mapping/pg-mapping-view/pg-mapping-view.component').then((m) => m.PgMappingViewComponent),
        canActivate: [authGuard, userMappingAccessGuard]
    },
    {
        path: 'user-mapping/pg-mapping-list',
        loadComponent: () =>
            import('../user-mapping/pg-mapping-list/pg-mapping-list.component').then((m) => m.PgMappingListComponent),
        canActivate: [authGuard, userMappingAccessGuard]
    },
    {
        path: 'user-mapping/shg-mapping-view',
        loadComponent: () =>
            import('../user-mapping/shg-mapping-view/shg-mapping-view.component').then(
                (m) => m.ShgMappingViewComponent
            ),
        canActivate: [authGuard, userMappingAccessGuard]
    },
    {
        path: 'user-mapping/shg-mapping-list',
        loadComponent: () =>
            import('../user-mapping/shg-mapping-list/shg-mapping-list.component').then(
                (m) => m.ShgMappingListComponent
            ),
        canActivate: [authGuard, userMappingAccessGuard]
    }
];
